import {getMethod, putMethod} from '~/api'

async function get() {
    return await getMethod('/api/voucherSettings')
}

async function put(request) {
    return await putMethod('/api/voucherSettings', request)
}

export {get, put}
